import store from "../redux/store";
import {
  hasChangesInCalendarManagement,
  invalidCalendarManagementKeys,
  validateCalendarManagement,
} from "../services-logic/calendar-management/calendar-management-logic";
import {
  hasChangesInCompanyDirectory,
  invalidCompanyDirectoryKeys,
  validateCompanyDirectory,
} from "../services-logic/company-directory/company-directory-logic";
import {
  hasChangesInKnowledgeBase,
  invalidKnowledgeBaseKeys,
  validateKnowledgeBase,
} from "../services-logic/knowledge-base/knowledge-base-logic";
import {
  hasChangesInYourReceptionist,
  validateYourReceptionist,
} from "../services-logic/your-receptionist/your-receptionist-logic";

export const getSaveButtonStatus = () => {
  const { updatedChannelId } = store.getState().info;
  const hasChangedInChannelSection = updatedChannelId && updatedChannelId.trim().length > 0;
  const hasChangesInYourReceptionistValue = hasChangesInYourReceptionist();
  const hasChangesInCompanyDirectoryValue = hasChangesInCompanyDirectory();
  const hasChangesInCalendarManagementValue = hasChangesInCalendarManagement();
  const hasChangesInKnowledgeBaseValue = hasChangesInKnowledgeBase();

  if (
    hasChangedInChannelSection ||
    hasChangesInYourReceptionistValue ||
    hasChangesInCompanyDirectoryValue ||
    hasChangesInCalendarManagementValue ||
    hasChangesInKnowledgeBaseValue
  ) {
    return true;
  }

  return false;
};

export const validateSave = async () => {
  const { updatedChannelId } = store.getState().info;
  if (!updatedChannelId || updatedChannelId.trim().length === 0) {
    return { valid: false, message: "Channel ID is required", elementId: "channel-id" };
  }

  const isValidSetupValue = validateYourReceptionist();
  if (!isValidSetupValue.valid) {
    return isValidSetupValue;
  }

  const isValidCompanyDirectoryValue = validateCompanyDirectory();
  const isValidCalendarManagementValue = validateCalendarManagement();
  const isValidKnowledgeBaseValue = validateKnowledgeBase();

  if (isKeyContains(invalidKnowledgeBaseKeys, isValidKnowledgeBaseValue.type)) {
    return isValidKnowledgeBaseValue;
  }

  if (isKeyContains(invalidCompanyDirectoryKeys, isValidCompanyDirectoryValue.type)) {
    return isValidCompanyDirectoryValue;
  }

  if (isKeyContains(invalidCalendarManagementKeys, isValidCalendarManagementValue.type)) {
    return isValidCalendarManagementValue;
  }

  // TODO: check combinations of invalid keys
  var invalidCount = 0;
  if (!isValidCompanyDirectoryValue.valid) {
    invalidCount++;
  }

  if (!isValidCalendarManagementValue.valid) {
    invalidCount++;
  }

  if (!isValidKnowledgeBaseValue.valid) {
    invalidCount++;
  }

  // if all the services are invalid
  if (invalidCount > 2) {
    return { valid: false, message: "At least one of the services must be entered." };
  }

  return { valid: true };
};

export const compareObjects = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const isKeyContains = (keys, key) => {
  if (!key) return false;
  return keys.some((k) => key.includes(k));
};
